<div class="row d-flex justify-content-between align-items-center">

  <div class="row">
    <div class="col-12">
      <div class="">
        <label class="form-check-label">
          {{ "inputs.exclude_brokers" | translate }}
        </label>
      </div>
    </div>
  </div>

    <div class="col-12" *ngIf="hasBrokerPrincipal && !isEditMode">
      <div class="alert alert-info mt-2">
        <i class="icon-info"></i>
        <strong>{{ "campaigns.info" | translate }}:</strong>
        {{ "campaigns.broker_principal_assigned" | translate }}
      </div>
    </div>

  <div class="mt-2" *ngIf="isEditMode">
    <label *ngIf="selectedItems.length > 0 && hasExcludedBrokersChanged()" class="form-label fst-italic">
      {{ selectedItems.length }}
      {{ selectedItems.length === 1
      ? ('campaigns.broker_selected_singular' | translate)
      : ('campaigns.broker_selected' | translate)
      }}
      <span class="delete_span" (click)="onSubmit()">
        {{ "campaigns.update_excluded_brokers" | translate }}
      </span>
    </label>


    <label *ngIf="selectedItems.length > 0 && !hasExcludedBrokersChanged()" class="form-label text-muted">
      {{selectedItems.length }} {{ "campaigns.brokers_currently_excluded" | translate }}
      <small class="text-muted">({{ "campaigns.no_changes_detected" | translate }})</small>
    </label>

    <label *ngIf="selectedItems.length === 0 && originalExcludedBrokers.length > 0" class="form-label">
      <span class="delete_span" (click)="onSubmit()">
        {{ "campaigns.update_excluded_brokers" | translate }}
      </span>
    </label>
    <label *ngIf="selectedItems.length === 0 && originalExcludedBrokers.length === 0" class="form-label text-muted">
      {{ "campaigns.no_brokers_selected_exclude" | translate }}
    </label>
  </div>

</div>
<div class="table-wrapper">
  <div class="table-container" #scrollableTable (scroll)="checkScroll($event)">
    <table>
      <thead>
        <tr>
          <th class="col-10">
            <input type="checkbox" (change)="toggleSelectAll($event)" [checked]="areAllSelected()">
          </th><!--
          <th class="col-20">{{ "campaigns.broker_reference" | translate }}</th> -->
          <th class="col-20">{{ "campaigns.broker_name" | translate }}</th>
        <!--   <th class="col-20">{{ "campaigns.broker_type" | translate }}</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let broker of filteredBrokerAccounts">
          <td class="col-10">
            <input type="checkbox" (change)="toggleSelection(broker)" [checked]="isSelected(broker)">
          </td>
         <!--  <td class="col-20">{{ broker.reference }}</td> -->
          <td class="col-20">{{ broker.name }}</td><!--
          <td class="col-20">{{ broker.type }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row mt-3" *ngIf="selectedItems.length > 0">
  <div class="col-6 ">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearSelection()">
      <i class="icon-cross2"></i>
      {{ "buttons.clear_selection" | translate }} ({{ selectedItems.length }})
    </button>
  </div>
</div>
<!--
<div class="total-container">
</div> -->
